import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

const yesNoAllOptions = [
    { value: "yes", label: "Yes" },
    { value: "All", label: "All" },
];

const yesNoOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
];

const priorityOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
];

const statusOptions = ["Created", "Saved", "Submitted", "Approved", "Rejected"].map(value => ({
    value,
    label: value,
}));

export const fields: FilterFieldConfig[] = [
    { key: "void", label: "Validity", type: "select", default: "", options: yesNoAllOptions },
    { key: "projectName", label: "Project Name", type: "text", default: "" },
    { key: "startDate", label: "Start Date", type: "range", default: "", inputType: "date" },
    { key: "endDate", label: "End Date", type: "range", default: "", inputType: "date" },
    { key: "pothole", label: "# of Potholes", type: "range", default: "", inputType: "number" },
    { key: "ep", label: "# of EPs", type: "range", default: "", inputType: "number" },
    { key: "manhole", label: "# of Manholes", type: "range", default: "", inputType: "number" },
    { key: "code", label: "Code", type: "text", default: "" },
    { key: "priority", label: "Priority", type: "select", default: "", options: priorityOptions },
    { key: "pending", label: "Pending", type: "select", default: "All", options: yesNoOptions },
    { key: "sup", label: "Supplementary Report", type: "select", default: "All", options: yesNoOptions },
    { key: "hasFile", label: "Has File", type: "select", default: "", options: yesNoOptions },
    { key: "reportTechEmail", label: "Report Tech", type: "text", default: "" },
    { key: "status", label: "Status", type: "select", default: "", options: statusOptions },
    { key: "notes", label: "Notes", type: "text", default: "" },
    { key: "projectManagerEmail", label: "Approver", type: "text", default: "" },
    { key: "approverNotes", label: "Approver Notes", type: "text", default: "" },
    { key: "createdBy", label: "Created By", type: "text", default: "" },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updatedBy", label: "Updated By", type: "text", default: "" },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
];

export default function ReportFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
